import { Box } from "@mui/material";
import { StepperProvider } from "../common/Providers/StepperProvider/StepperProvider";

const RentalLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <StepperProvider>
      <Box sx={styles.outerWrapper}>
        <Box sx={styles.innerWrapper}>
          {children}
        </Box>
      </Box>
    </StepperProvider>
  );
};

const styles = {
  outerWrapper: {
    backgroundColor: "#191919",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  innerWrapper: {
    width: "100%",
    maxWidth: {
      xs: "100%",
      sm: "960px",
    },
  },
};

export default RentalLayout;
